const empty = () => import("@core/components/empty.vue");
const columnList = () => import("./views/columnList.vue");
const addColumn = () => import("./views/addColumn.vue");
const selectTmp = () => import("./views/selectTmp.vue")
export default {
  // 栏目管理
  path: 'column',
  name: 'columnBox',
  component: empty,
  children: [
    {
      path: '/columnList',
      name: 'columnList',
      component: columnList,
      meta: '/inforMan'
    },
    {
      path: "/addColumn",
      name: "addColumn",
      component: addColumn,
      meta: {
        parentRoot: "/columnList", // 导航高亮
        root: "/inforMan"
      }
    },
    {
      path: "/selectTmp", //选择模板
      name: "selectTmp",
      component: selectTmp,
      meta: {
        parentRoot: "/columnList", // 导航高亮
        root: "/inforMan"
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/core/modules/column/router.js